module.exports = __webpack_public_path__ + "static/media/customers.be236ab5.svg";